
import { mapGetters, mapActions } from 'vuex';
import AlertModule from 'vux/src/plugins/alert/module'




export default {
components: {},
name: 'reviewlist',
props: ['hasComment', 'portrait'],
data() {
return {
commentTag: false,
commentList: [
{
portrait: './images/teacher-img.png',
name: '文天祥',
date: '2018-11-08',
content: '老师讲的很专业，课程由浅到深，很适合我',
score: 4
},
{
portrait: './images/teacher-img.png',
name: '文天祥',
date: '2018-11-08',
content: '老师讲的很专业，课程由浅到深，很适合我',
score: 4
},
{
portrait: './images/teacher-img.png',
name: '文天祥',
date: '2018-11-08',
content:
'学完老师的课程，被深深地吸引住了，非常惊喜。希望老师再出新课程。',
score: 3
}
],
courseId: null 
};
},
methods: {
...mapActions(['getDistrict'])








































},
watch: {},
computed: {
...mapGetters([])
},
created() {


},
mounted() {}
};
